/**
 * Événements légers du tableau de bord : gtag (si présent) + CustomEvent "entrea:analytics"
 * pour branchement ultérieur (Plausible, Matomo, etc.) sans coupler l'UI.
 *
 * Noms d'événements (snake_case) : dashboard_deposit_row_expand, dashboard_assistance_cta, …
 */
export function trackDashboardEvent(name, detail = {}) {
  if (typeof window === 'undefined') return;
  const payload = { event_category: 'dashboard', ...detail };
  if (typeof window.gtag === 'function') {
    try {
      window.gtag('event', name, payload);
    } catch {
      /* ignore */
    }
  }
  try {
    window.dispatchEvent(
      new CustomEvent('entrea:analytics', {
        detail: { name, ...detail },
      })
    );
  } catch {
    /* ignore */
  }
}
